"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MediaQueryListener = _interopRequireDefault(require("../../../shared/helpers/MediaQueryListener"));

var _ClickableImageTemplate = _interopRequireDefault(require("./templates/ClickableImageTemplate/ClickableImageTemplate"));

var _CategoryTemplate = _interopRequireDefault(require("./templates/CategoryTemplate/CategoryTemplate"));

var _BasicTemplate = _interopRequireDefault(require("./templates/BasicTemplate/BasicTemplate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var templateMap = {
  Basic: _BasicTemplate["default"],
  Category: _CategoryTemplate["default"],
  'Clickable Image': _ClickableImageTemplate["default"]
};

var ResponsiveHero = /*#__PURE__*/function (_Component) {
  _inherits(ResponsiveHero, _Component);

  var _super = _createSuper(ResponsiveHero);

  function ResponsiveHero(props) {
    var _this;

    _classCallCheck(this, ResponsiveHero);

    _this = _super.call(this, props);
    var _props$sliceData$prim = props.sliceData.primary,
        template = _props$sliceData$prim.responsive_page_hero_template,
        desktopImage = _props$sliceData$prim.responsive_page_hero_desktop_image;
    _this.state = {
      image: desktopImage
    };
    _this.TemplateComponent = templateMap[template];
    _this.setImage = _this.setImage.bind(_assertThisInitialized(_this));
    _this.mq = new _MediaQueryListener["default"](function () {
      return _this.setImage();
    });
    return _this;
  }

  _createClass(ResponsiveHero, [{
    key: "setImage",
    value: function setImage() {
      var _this$props$sliceData = this.props.sliceData.primary,
          desktopImage = _this$props$sliceData.responsive_page_hero_desktop_image,
          mobileImage = _this$props$sliceData.responsive_page_hero_mobile_image;
      var image = this.mq.atMinWidth('tablet') ? desktopImage : mobileImage;
      this.setState({
        image: image
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataClient = _this$props.dataClient,
          _this$props$sliceData2 = _this$props.sliceData.primary,
          title = _this$props$sliceData2.responsive_page_hero_title,
          subtitle = _this$props$sliceData2.responsive_page_hero_summary,
          buttonText = _this$props$sliceData2.responsive_page_hero_button,
          linkTo = _this$props$sliceData2.responsive_page_hero_link;
      var image = this.state.image;
      return /*#__PURE__*/_react["default"].createElement(this.TemplateComponent, {
        dataClient: dataClient,
        title: title,
        subtitle: subtitle,
        linkTo: linkTo,
        image: image,
        buttonText: buttonText
      });
    }
  }]);

  return ResponsiveHero;
}(_react.Component);

ResponsiveHero.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({}).isRequired
};
var _default = ResponsiveHero;
exports["default"] = _default;